var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm.LOADING
        ? _c("application-navbar-loader")
        : _c("div", { staticClass: "row w-100 justify-content-center" }, [
            _vm.showMenuToggler
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "observe-visibility",
                        rawName: "v-observe-visibility",
                        value: _vm.handleCheckSidebarResponsive,
                        expression: "handleCheckSidebarResponsive",
                      },
                    ],
                    staticClass:
                      "col-2 col-md-auto px-3 align-items-center justify-content-center",
                    class: {
                      "d-md-none d-flex": _vm.showSidebar,
                      "d-flex": !_vm.showSidebar,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "sidebar-toggler",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleSidebar },
                      },
                      [
                        _c("span", { staticClass: "d-none" }, [
                          _vm._v(_vm._s(_vm.$t("global.actions.openSideMenu"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fa fa-bars fa-1x" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "logo" }, [
                      _c("a", { staticClass: "clickable" }, [
                        _c("img", {
                          staticClass: "logo-img",
                          attrs: {
                            alt: _vm.$t("global.words.filogixLogo"),
                            src: _vm.$options.filters.getLogo(),
                          },
                        }),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-10 col-md steps my-auto" }, [
              _c(
                "div",
                {
                  staticClass:
                    "row justify-content-md-start align-items-center step-bar flex-nowrap",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "step col-lg d-flex justify-content-center align-items-start flex-column col-auto step-controls d-md-none clickable",
                      class: {
                        completed: false,
                      },
                      on: { click: _vm.goPrev },
                    },
                    [
                      _c("p", { staticClass: "step-count" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.words.prev")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "step-title step-title-inline-icon d-flex flex-row flex-nowrap align-items-center text-center text-truncate",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-arrow-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.tabs, function (tab, index) {
                    return _c(
                      "div",
                      {
                        key: tab.name,
                        staticClass:
                          "step d-flex justify-content-center align-items-center flex-column col align-self-start",
                        class: {
                          completed: index < _vm.currentStepIndex,
                          clickable: true,
                          navigatable: true,
                          current: true,
                          selected: index === _vm.currentStepIndex,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goEdit(tab.name)
                          },
                        },
                      },
                      [
                        _c("p", { staticClass: "step-count" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("global.words.stepNumber", {
                                  stepNumber: index + 1,
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "step-title step-title-inline-icon d-flex flex-row flex-nowrap align-items-center text-center",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t(tab.label)) +
                                "\n            "
                            ),
                            _vm.isStepCompleted(tab.name, index)
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-check d-none step-title-icon ml-1",
                                  attrs: { "aria-hidden": "true" },
                                })
                              : [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation d-none step-title-icon ml-1",
                                    attrs: {
                                      id: "step-" + index,
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("notification-popover", {
                                    attrs: { target: "step-" + index },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "popoverContent",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application-standalone.pages.pleaseReviewThisSection"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                          ],
                          2
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "step col-lg d-flex justify-content-center align-items-center flex-column col-auto step-controls d-md-none clickable",
                      class: {
                        completed: false,
                      },
                      on: { click: _vm.goNext },
                    },
                    [
                      _c("p", { staticClass: "step-count" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.words.next")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "step-title step-title-inline-icon d-flex flex-row flex-nowrap align-items-center text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-arrow-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 mt-2 px-0 app-progress-bar-wrapper" },
                [
                  _c("div", { staticClass: "progress-bar" }, [
                    _c("div", {
                      staticClass: "fill-bar",
                      style: {
                        transition: "all 1s ease-in-out",
                        transform:
                          "translateX(-" + _vm.progressPercentage + "%)",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }